export const AUTH_EXPIRED_TOKEN = "auth/expiredToken"

export const ALERT_DIALOG_FIRE = "alertService/FIRE_ALERT_DIALOG"
export const LOADING_SCREEN_OVERLAY_FIRE =
  "loadingScreenOverlayService/LOADING_SCREEN_OVERLAY_FIRE"
export const LOADING_SCREEN_OVERLAY_CLOSE =
  "loadingScreenOverlayService/LOADING_SCREEN_OVERLAY_CLOSE"
